

import  config_ from './base/config'
Vue.prototype.config = config_
import base_ from './base/base'
Vue.use(base_)
import axios from 'axios'
axios.defaults.withCredentials = false 
Vue.prototype.axios_ = axios


Vue.prototype.$setTitle = function (t) {
document.title = t
}

import htmlToPdf from './components/utils/htmlToPdf'
Vue.use(htmlToPdf)

import Print from './components/utils/print'
Vue.use(Print)

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import './assets/font/iconfont.css'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import Toast from 'vux/src/components/toast/index.vue'

import ToastPlugin from 'vux/src/plugins/toast/index.js'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.component('toast', Toast)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)

NProgress.inc(0.2)
NProgress.configure({
easing: 'ease',  // 动画方式
speed: 500,  // 递增进度条的速度
showSpinner: false, // 是否显示加载ico
trickleSpeed: 200, // 自动递增间隔
minimum: 0.3 
})

import store from './base/store'


router.beforeEach((to, from, next) => {
if (to.meta.title) {
document.title = to.meta.title;
}
document.querySelector('meta[name="keywords"]').setAttribute('content', '网站关键字')
document.querySelector('meta[name="description"]').setAttribute('content', '网站描述')

if (to.path === '/login' || to.path === '/admin' ||  to.path === '/roomDetail' ||  to.path === '/workDetail') {
next();
} else {
let userid = sessionStorage.getItem('verifyData_userid');

if (userid === null || userid ==='0' || userid ==='') {
next({path: "/admin"});
} else {
NProgress.start()
next();
}
}
});
router.afterEach(() => {
NProgress.done()
})


import Vue from 'vue'
import App from './App'
import router from './router'




import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);



import './static/css/main.css'

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

Vue.config.productionTip = false

import scroller from './components/scroller'
Vue.component('zk-scroller', scroller)

Vue.prototype.$tableConHeight = function(result){
let height = 0








height = document.body.offsetHeight*1 - 130
if (height < 300) {
height = 300
}
console.log(height)
return height
}

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>',
render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js